<template>
    <SelectDropDown
            :id="id"
            :name="name"
            :label="label"
            @selection-change="generalStatusSelected"
            :options="statuses"
            :defaultSelected="statuses[0]"
    />
</template>

<script>
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import sharedService from "@/services/shared.service";

    export default {
        name: "GeneralStatusDropdown",
        components: {SelectDropDown},
        props: {
            id: String,
            name: String,
            label: String,
        },
        created() {
            sharedService.fetchAllGeneralStatuses()
                .then(({data}) => {
                    this.statuses.push({
                        id: 'none',
                        name: '(всички)'
                    });
                    data.forEach(region => this.statuses.push(region));
                });
        },
        data() {
            return {
                statuses: []
            }
        },
        methods: {
            generalStatusSelected(value) {
                this.$emit('selection-change', {
                    id: value.dropDownId,
                    isDropdown: true,
                    name: value.name,
                    label: value.label,
                    currentValueId: value.currentValue.id === 'none' ? '' : value.currentValue.id,
                    currentValue: value.currentValue.id === 'none' ? '' : value.currentValue.name,
                    oldValue: value.oldValue
                });
            }
        }
    }
</script>

<style scoped>

</style>
